(() => {
    "use strict";

    async function loadMore(button) {
        const container = document.getElementById("blog-posts");
        if (!button || !container || button.getAttribute("aria-busy") === "true") {
            return;
        }

        const page = Number(button.dataset.nextPage || 2);
        const totalPages = Number(button.dataset.totalPages || 1);
        const params = new URLSearchParams({
            pagina: String(page),
            fragment: "posts",
        });
        if (button.dataset.term) params.set("termo", button.dataset.term);
        if (button.dataset.category) params.set("categoria", button.dataset.category);

        button.setAttribute("aria-busy", "true");
        try {
            const response = await fetch(`${button.dataset.baseUrl}?${params}`, {
                headers: { "X-Requested-With": "XMLHttpRequest" },
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const template = document.createElement("template");
            template.innerHTML = (await response.text()).trim();
            container.append(template.content);

            const nextPage = page + 1;
            if (page >= totalPages) {
                button.closest(".blog-load-more")?.remove();
                return;
            }

            button.dataset.nextPage = String(nextPage);
            const fallback = new URL(button.href, window.location.origin);
            fallback.searchParams.set("pagina", String(nextPage));
            button.href = fallback.toString();
        } catch (error) {
            window.location.assign(button.href);
        } finally {
            button.removeAttribute("aria-busy");
        }
    }

    function boot() {
        const button = document.querySelector("[data-blog-load-more]");
        if (!button || button.dataset.bound === "true") {
            return;
        }
        button.dataset.bound = "true";
        button.addEventListener("click", (event) => {
            event.preventDefault();
            loadMore(button);
        });
    }

    window.siteReady(boot);
})();
